import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import { PostHogRootProvider } from '@/lib/posthog/PostHogContext';

// The loader is a leaf that renders null, so being client-only never blocks SSR
// of the app tree
const PostHogLoader = dynamic(() => import('./PostHogLoader'), { ssr: false });

export default function PostHogProvider({ children }: { children: ReactNode }) {
  return (
    <PostHogRootProvider>
      <PostHogLoader />
      {children}
    </PostHogRootProvider>
  );
}
